import { useMemo } from 'react'
import boyImg from 'assets/images/default_boy.png'
import girlImg from 'assets/images/default_girl.png'
import manImg from 'assets/images/default_man.png'
import womanImg from 'assets/images/default_woman.png'
import {
  GenderIdentity,
  IPersonalDetails,
} from 'types/interfaces/IPersonalDetails'
import { dateService } from 'services/date.service'
import { favoritePlayerOptions } from 'shared/constants/favoritePlayerOptions'
import { Relationships } from 'store/api-slices/userSlice'

const ADULT_AGE = 18

export const useUserImage = (
  userDetails?: IPersonalDetails,
  relationshipDetails?: Relationships,
): string => {
  const user = userDetails ? userDetails : relationshipDetails
  const age: number = dateService.calculateAge(user?.dob)

  const getAvatarByAgeAndGender = (
    age: number | null,
    gender: GenderIdentity | undefined,
  ): string => {
    if (gender === GenderIdentity.MALE) {
      return !age || age < ADULT_AGE ? boyImg : manImg
    }
    if (gender === GenderIdentity.FEMALE) {
      return !age || age < ADULT_AGE ? girlImg : womanImg
    }
    // Default when gender is undefined
    return age && age >= ADULT_AGE ? manImg : boyImg
  }

  return useMemo(() => {
    if (user?.playerImage)
      return favoritePlayerOptions[Number(user.playerImage)].src
    return getAvatarByAgeAndGender(age, user?.gender)
  }, [user])
}
